(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trustpilot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('trustpilot-carousel')) return;

    var SWIPE_THRESHOLD = 40;

    function formatRelative(value) {
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((value || '').trim());
      if (!m) return null;
      var date = new Date(+m[1], +m[2] - 1, +m[3]);
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var days = Math.max(0, Math.round((today - date) / 86400000));
      if (days === 0) return 'Today';
      if (days === 1) return '1 day ago';
      if (days <= 30) return days + ' days ago';
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }

    class TrustpilotCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.slides = Array.prototype.slice.call(this.track.children);
        this.index = 0;

        this.updateDates();

        this.prevBtn.addEventListener('click', () => this.goTo(this.index - this.perView));
        this.nextBtn.addEventListener('click', () => this.goTo(this.index + this.perView));

        this.bindTouch();

        // Theme editor: jump to the selected block
        this.addEventListener('shopify:block:select', (event) => {
          var i = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
          if (i > -1) this.goTo(i, false);
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update(false));
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.update(false));
        }

        this.update(false);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get perView() {
        var value = parseInt(getComputedStyle(this).getPropertyValue('--per-view'), 10);
        return Math.max(1, value || 1);
      }

      get maxIndex() {
        return Math.max(0, this.slides.length - this.perView);
      }

      offsetFor(i) {
        var slide = this.slides[i];
        return slide ? slide.offsetLeft - this.slides[0].offsetLeft : 0;
      }

      goTo(i, animate) {
        this.index = Math.min(Math.max(0, i), this.maxIndex);
        this.render(animate !== false);
      }

      update(animate) {
        this.index = Math.min(this.index, this.maxIndex);
        this.render(animate);
      }

      setTranslate(x) {
        this.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      }

      render(animate) {
        if (!animate) {
          this.track.style.transition = 'none';
          this.setTranslate(-this.offsetFor(this.index));
          void this.track.offsetWidth;
          this.track.style.transition = '';
        } else {
          this.track.style.transition = '';
          this.setTranslate(-this.offsetFor(this.index));
        }

        this.prevBtn.disabled = this.index <= 0;
        this.nextBtn.disabled = this.index >= this.maxIndex;

        var per = this.perView;
        this.slides.forEach((slide, i) => {
          var visible = i >= this.index && i < this.index + per;
          slide.toggleAttribute('inert', !visible);
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }

      // Touch-only dragging (mouse dragging stays off on desktop)
      bindTouch() {
        var startX = 0, startY = 0, dx = 0, axis = null, base = 0;

        this.viewport.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          dx = 0;
          axis = null;
          base = this.offsetFor(this.index);
          this.dragged = false;
        }, { passive: true });

        this.viewport.addEventListener('touchmove', (e) => {
          if (e.touches.length !== 1) return;
          var moveX = e.touches[0].clientX - startX;
          var moveY = e.touches[0].clientY - startY;

          if (axis === null && (Math.abs(moveX) > 6 || Math.abs(moveY) > 6)) {
            axis = Math.abs(moveX) > Math.abs(moveY) ? 'x' : 'y';
          }
          if (axis !== 'x') return;

          e.preventDefault();
          dx = moveX;
          this.dragged = true;

          var atStart = this.index <= 0 && dx > 0;
          var atEnd = this.index >= this.maxIndex && dx < 0;
          var drag = atStart || atEnd ? dx / 3 : dx;

          this.track.style.transition = 'none';
          this.setTranslate(-base + drag);
        }, { passive: false });

        var end = () => {
          if (axis === 'x') {
            this.track.style.transition = '';
            if (Math.abs(dx) > SWIPE_THRESHOLD) {
              this.goTo(this.index + (dx < 0 ? this.perView : -this.perView));
            } else {
              this.render(true);
            }
          }
          axis = null;
        };

        this.viewport.addEventListener('touchend', end);
        this.viewport.addEventListener('touchcancel', end);

        // Don't open a review link right after a swipe
        this.viewport.addEventListener('click', (e) => {
          if (this.dragged) {
            e.preventDefault();
            e.stopPropagation();
            this.dragged = false;
          }
        }, true);
      }

      // Refresh "x days ago" in the visitor's browser so cached pages stay accurate
      updateDates() {
        this.querySelectorAll('[data-review-date]').forEach((el) => {
          var label = formatRelative(el.getAttribute('data-review-date'));
          if (label) el.textContent = label;
        });
      }
    }

    customElements.define('trustpilot-carousel', TrustpilotCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
